import React from 'react';

type nameOfList = "Category" | "Roles" | "Technology";

export interface IProjectList {
    nameOfList: nameOfList;
    items: Array<string>;
}

function ProjectList(props: IProjectList) {

    const list = props.items.map((item: string, index: number) => {
        return (
            <li key={index}>
                {item}
            </li>
        )
    })

    return (
        <div className="project-list">
            <ul>
                <li><h4>{props.nameOfList}</h4></li>
                {list}
            </ul>
        </div>

    );
}


export default ProjectList;